type AreaType = (typeof AREA_TYPES)[number];

const AREA_TYPES = ['city', 'town'] as const;

export type { AreaType };
export { AREA_TYPES };
